import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, onValue, push, query, orderByChild } from "firebase/database";
import { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2'
import KeyboardBack from '@mui/icons-material/KeyboardBackspace'
import { Button, Card, CardContent, IconButton } from '@mui/material';
import { useNavigate } from 'react-router';

const firebaseConfig = {
    apiKey: "AIzaSyA8TopHMkPlDZRaKUv7bpaMnnYgfHDxMc4",
    authDomain: "lybra-pricing.firebaseapp.com",
    projectId: "lybra-pricing",
    storageBucket: "lybra-pricing.appspot.com",
    messagingSenderId: "127223574332",
    appId: "1:127223574332:web:4cea6a20e9c27603a4f839",
    measurementId: "G-NFK626DC0R",
    databaseURL: "https://lybra-pricing-default-rtdb.europe-west1.firebasedatabase.app/"
};
  
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export default function StatsTable () {

    const [tableData, setTableData] = useState([])
    const [users, setUsers] = useState([])
    const [quotes, setQuotes] = useState([])

    useEffect(() => {
        const usersRef = ref(database, 'users')
        onValue(usersRef, (snapshot) => {
            setUsers(snapshot.val())
        }, {
            onlyOnce: true
        })


        const quotesRef = ref(database, 'quotes')
        onValue(quotesRef, (snapshot) => {
            setQuotes(snapshot.val())
        }, {
            onlyOnce: true
        })
    }, [])

    useEffect(() => {
        const data = []
    }, [ tableData ])

    const navigate = useNavigate()

    useEffect(() => {
        if (users && quotes) {

            const rows = []
            Object.keys(users).forEach(userSub => {
                
                const row = {
                    userName: users[userSub].name,
                    quoteCount: 0,
                    annual: 0,
                    avgMonth: 0,
                    avgSetupDiscount: 0,
                    avgDiscount: 0,
                    avgDuration: 0
                }

                const userQuotes = quotes[userSub]
                
                if (userQuotes) {
                    const quoteObjects = Object.keys(userQuotes).map(key => userQuotes[key])
                    // annual sales quotes
                    //sub quotes                    
                    row.quoteCount = quoteObjects.reduce((prev, curr) => prev + (curr.quote.subQuotes ? curr.quote.subQuotes.length : 0), 0)
                    row.avgSetupDiscount = quoteObjects.reduce((prev, curr) => prev + (curr.quote.subQuotes ? curr.quote.subQuotes.reduce((spre, scur) => spre + scur.setupDiscount, 0) : 0), 0)
                    row.avgDiscount = quoteObjects.reduce((prev, curr) => prev + (curr.quote.subQuotes ? curr.quote.subQuotes.reduce((spre, scur) => spre + scur.extraDiscount, 0) : 0), 0)
                    
                    row.quoteCount += quoteObjects.length
                    row.annual = quoteObjects.filter(q => !q.accepted).reduce((prev, curr) => prev + curr.totals.annual, 0)
                    row.avgMonth = (quoteObjects.reduce((prev, curr) => prev + (isNaN(curr.totals.month) ? 0 : curr.totals.month), 0)) / row.quoteCount

                    row.avgSetupDiscount += quoteObjects.reduce((prev, curr) => prev + curr.quote.setupDiscount, 0)
                    row.avgDiscount += quoteObjects.reduce((prev, curr) => prev + curr.quote.extraDiscount, 0)
                    row.avgSetupDiscount = row.avgSetupDiscount / row.quoteCount
                    row.avgDiscount = row.avgDiscount / row.quoteCount

                    row.avgDuration += quoteObjects.reduce((prev, curr) => prev + curr.quote.duration, 0)
                    row.avgDuration = row.avgDuration/row.quoteCount

                    row.conversionRate = quoteObjects.filter(q => q.accepted).reduce((prev, curr) => prev + 1 + (curr.quote.subQuotes ? curr.quote.subQuotes.length: 0), 0) / row.quoteCount * 100
                    row.conversionValue = (quoteObjects.filter(q => q.accepted).reduce((prev, curr) => {
                        const method = curr.accepted.method
                        if (method === 'annual') return prev + curr.totals.annual
                        if (method === 'semester') return prev + curr.totals.semester * 2
                        if (method === 'monthly') return prev + curr.totals.month * 12
                    }, 0))
                }

                rows.push(row)
            })

            setTableData(rows.sort((a, b) => {
                if (a.quoteCount > b.quoteCount) {
                  return -1
                }
                if (b.quoteCount > a.quoteCount) {
                  return 1
                }
                return 0
            }))
        }
    }, [users, quotes])

    function generateCSV () {

        let rows = [
            [
                'Sales',
                'Preventivi',
                'Totale preventivato',
                'Media Mensile',
                'Media sconto setup %',
                'Media sconto canone %',
                'Conversion rate %'
            ].join(';') + '\r\n'
        ]

        rows = [...rows, ...tableData.map(row => {
            const values = Object.values(row)
            const csvRow = values.join(';')
            return csvRow + '\r\n'
        })]

        const content = "data:text/csv;chartset=utf-8," + rows.join('')
        const encodedUri = encodeURI(content)
        const link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', 'sales_stats.csv')
        document.body.append(link)
        link.click()

    }

    return (
        <div style={{
            paddingTop: '1rem'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'center'
            }}>
                <img
                    style={{ display: 'inline-block' }}
                    src="https://lybra.tech/wp-content/uploads/2021/04/logopositivo.png" />
            </div>
            <div style={{
                padding: '2rem',
                fontSize: '1.8rem',
                paddingBottom: 0,
                display: 'flex',
                alignItems: 'center'
            }}>
                <div style={{ marginRight: '1rem' }}>
                    <IconButton onClick={() => {
                        navigate('/')
                    }}>
                        <KeyboardBack />
                    </IconButton>
                </div>
                <div>Statistiche sales</div>
            </div>
            <div style={{
                padding: '2rem'
            }}>
                <Button
                    onClick={generateCSV}
                    style={{ marginBottom: '1rem' }}
                    variant={'contained'}>Esporta</Button>
                <Card style={{ marginBottom: '2rem' }} sx={{
                        borderRadius: '10px'
                        }}>
                    <CardContent>
                        <div style={{ height: '400px' }}>
                            <Bar
                                options={{
                                    maintainAspectRatio: false,
                                    scales: {
                                        x: {
                                            stacked: true
                                        },
                                        y: {
                                            stacked: true
                                        }
                                    }
                                }}
                                data={{
                                    labels: tableData.map(td => td.userName),
                                    datasets: [{
                                        label: 'Totale preventivato',
                                        data: tableData.map(td => td.annual),
                                        backgroundColor: [
                                            'rgb(28,144,188)'
                                        ]
                                    }, {
                                        label: 'Totale accettato',
                                        data: tableData.map(td => td.conversionValue),
                                        backgroundColor: [
                                            'rgb(65,207,37)'
                                        ]
                                    }]
                                }} />
                        </div>
                    </CardContent>
                </Card>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                        <TableRow>
                            <TableCell>Sales</TableCell>
                            <TableCell align="right">Preventivi</TableCell>
                            <TableCell align="right">Totale preventivato</TableCell>
                            <TableCell align="right">Media mensile</TableCell>
                            <TableCell align="right">Media sconto setup %</TableCell>
                            <TableCell align="right">Media sconto canone %</TableCell>
                            <TableCell align="right">Durata media</TableCell>
                            <TableCell align="right">Conversion rate %</TableCell>
                            <TableCell align="right">Conversion value</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {
                            tableData.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                    <TableCell component="th" scope="row">
                                        {row.userName}
                                    </TableCell>
                                    <TableCell  align="right">
                                        {row.quoteCount}
                                    </TableCell>
                                    <TableCell align="right">{isNaN(row.annual) ? '0' : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(row.annual)}</TableCell>
                                    <TableCell align="right">{isNaN(row.avgMonth) ? '0' : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(row.avgMonth)}</TableCell>
                                    <TableCell align="right">{isNaN(row.avgSetupDiscount) ? '0' : Math.round(row.avgSetupDiscount).toFixed(0)}%</TableCell>
                                    <TableCell align="right">{isNaN(row.avgDiscount) ? '0' : Math.round(row.avgDiscount).toFixed(0)}%</TableCell>
                                    <TableCell align="right">{isNaN(row.avgDuration) ? '0' : Math.round(row.avgDuration).toFixed(0)}m</TableCell>
                                    <TableCell align="right">{isNaN(row.conversionRate) ? '0' : Math.round(row.conversionRate).toFixed(0)}%</TableCell>
                                    <TableCell align="right">{isNaN(row.conversionValue) ? '0' : Math.round(row.conversionValue).toFixed(0)} €</TableCell>
                                </TableRow>
                            ))
                        }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    )

}